import { styled } from '@clickcease/cc-client-components-lib'

export const DashboardWrapper = styled('div', {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const LoaderWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '100px',
})

export const CountriesSection = styled('div', {
  display: 'flex',
  width: '100%',
  gap: '20px',
  minHeight: '530px',
})

export const BMDashboardStyled = styled('div', {
  width: '100%',
  flex: '1',
})

export const BMDashboardPDF = styled('div', {
  zoom: '66%',
  width: '1260px',
  height: '1680px',
  '@media print': { '@page': { size: 'portait !important;' } },
  '@media only screen': { display: 'none' },
  position: 'absolute',
  zIndex: '-5000',
  background: '$offwhite',
  top: '0',
  fontFamily: 'Open Sans',
  padding: '$10',
  margin: '0px 20px',
})
